/** @format */

import type { LoginAdmin } from "infrastructure/interfaces/login.interface";
import storage from "infrastructure/utils/storage";
import {
  DEFAULT_NOTIFICATIONS_CHANNEL_TYPE,
  NotificationsChannelType,
  resolveNotificationsChannelType,
} from "./realtime/channel";

export const NOTIFICATION_RECIPIENT_ID_KEY = "notification_recipient_id";
export const NOTIFICATION_CHANNEL_TYPE_KEY = "notification_channel_type";

export const persistNotificationSessionFromLogin = (admin: LoginAdmin | undefined) => {
  if (admin?.id != null) {
    storage.setItem(NOTIFICATION_RECIPIENT_ID_KEY, String(admin.id));
  }

  storage.setItem(NOTIFICATION_CHANNEL_TYPE_KEY, "admin");
};

export const clearNotificationSession = () => {
  storage.clearItem(NOTIFICATION_RECIPIENT_ID_KEY);
  storage.clearItem(NOTIFICATION_CHANNEL_TYPE_KEY);
};

export const resolveNotificationRecipientId = (): string | null => {
  const storedId = storage.getItem(NOTIFICATION_RECIPIENT_ID_KEY);
  if (storedId) {
    return storedId;
  }

  const token = storage.getItem("access_token");
  if (!token) {
    return null;
  }

  const parts = token.split(".");
  if (parts.length < 2) {
    return null;
  }

  try {
    const payload = JSON.parse(atob(parts[1])) as Record<string, unknown>;
    const id = payload.id || payload.sub || payload.user_id;
    return typeof id === "string" || typeof id === "number" ? String(id) : null;
  } catch (_error) {
    return null;
  }
};

export const resolveNotificationChannelType = (): NotificationsChannelType => {
  const stored = storage.getItem(NOTIFICATION_CHANNEL_TYPE_KEY);
  if (stored) {
    return resolveNotificationsChannelType(stored);
  }

  return resolveNotificationsChannelType(
    process.env.REACT_APP_NOTIFICATIONS_CHANNEL_TYPE ??
      DEFAULT_NOTIFICATIONS_CHANNEL_TYPE
  );
};
